import script from "./InfoBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoBadge.vue?vue&type=script&setup=true&lang=js"

import "./InfoBadge.vue?vue&type=style&index=0&id=324f7b20&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-324f7b20"]])

export default __exports__